export function emitJson(data: unknown): void {
  console.log(JSON.stringify(data, null, 2));
}

export function emitHuman(lines: string[]): void {
  for (const line of lines) {
    console.log(line);
  }
}
